import { useCallback, useEffect } from 'react';
import handleAPIError from 'src/api/errors';
import { citiesAPI } from 'src/api/requests/citiesAPI';
import useLocationStore from 'src/hooks/useLocationStore';
import { useRouter } from 'next/router';
import axios from 'axios';
import debounce from 'lodash/debounce';

export const useLocationHooks = () => {
  const { locale } = useRouter();
  const {
    userLocation,
    cities,
    setCities,
    setDefaultLocation,
    setUserLocation,
    setStoreLocation,
    storeInitilized
  } = useLocationStore();

  const loadAllCities = async () => {
    try {
      // retrieve IP on client side
      const ip = (await axios.get('/api/get-ip-address'))?.data;
      const response = await citiesAPI({ ip, attr: { locale } });
      setCities(response);
      const nearestCity = response?.find((city) => city.nearest);
      if (!userLocation) {
        setDefaultLocation(nearestCity);
        setUserLocation(nearestCity);
      }
      setStoreLocation(null);
    } catch (error) {
      handleAPIError(error);
    }
  };

  const debouncedLoadAllCities = useCallback(
    debounce(() => loadAllCities(), 250),
    [setCities, setDefaultLocation, setUserLocation, setStoreLocation, locale]
  );

  useEffect(() => {
    if (storeInitilized) {
      debouncedLoadAllCities();
    }
  }, [storeInitilized, locale, debouncedLoadAllCities]);

  useEffect(() => {
    if ((cities?.length === 0 || !userLocation?.name) && storeInitilized) {
      debouncedLoadAllCities();
    }
  }, [
    storeInitilized,
    userLocation?.name,
    JSON.stringify(cities),
    debouncedLoadAllCities
  ]);
};
